module.exports = __webpack_public_path__ + "img/01_Cladding Metal.0d2ca659.png";